var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CrudList',{attrs:{"title":"Review","storeName":"Reviews","parentStoreName":"notifications_cms","labelAddNew":"Agregar","parentUrlKey":"spot_id","canAdd":false,"canEdit":false,"labelBack":"Atrás","sortable":"","breadcrumbs":[
      {
        text: 'Spots y vehículos',
        disabled: false,
        href: '/admin/notifications_cms'
      },
      {
        text: '...',
        disabled: false,
        href: '#'
      },
      {
        text: 'Reviews',
        disabled: false,
        href: '#'
      },
    ]},scopedSlots:_vm._u([{key:"short_user",fn:function({ item }){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[(item.short_user)?_c('v-col',{attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(item.short_user.name)+" "+_vm._s(item.short_user.last_name)+" ")]):_vm._e()],1)]}},{key:"tags",fn:function({ item }){return [_c('v-row',{attrs:{"align":"center","justify":"center"}},[(item.tags && item.tags.length > 0)?_c('v-col',{attrs:{"cols":"12"}},_vm._l((item.tags),function(tag,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(tag.name)+" ")])}),0):_c('v-col',{attrs:{"cols":"12"}})],1)]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }